import useSWR from 'swr';
import { trpc } from '../../../api/trpc';

export const useUtmList = () => {
  const { data, isLoading, error, mutate } = useSWR(['utmAdmin.list'], () =>
    trpc.utmAdmin.list.query(),
  );

  return { data, isLoading, error, mutate };
};
